<!--
 * @Description: 注册
 * @Author: yingbin
 * @Date: 2019-08-26 15:13:26
 * @LastEditTime: 2019-09-09 17:00:40
 * @LastEditors: yingbin
 -->
<template>
  <div class="registers">
    <v-header></v-header>
    <div class="emptyheader"></div>
    <div class="registers-layout">
      <div class="left">
        <img src="@/assets/images/login-left.png" alt="">
      </div>
      <div class="right">
        <div class="title">注册</div>
        <div class="middle">
          <el-form ref="registerForm" :model="registerForm" :rules="rules">
            <el-form-item prop="phone">
              <div class="icon">
                <img src="@/assets/images/form-phone.png" alt="">
              </div>
              <el-input placeholder="请输入手机号" v-model="registerForm.phone" maxlength="11"></el-input>
            </el-form-item>            
            <el-form-item prop="password">
              <div class="icon">
                <img src="@/assets/images/password.png" alt="">
              </div>
              <el-input
                placeholder="请设置6-16位数字、字母组合密码"
                type="password"
                v-model="registerForm.password"
                maxlength="16"
              ></el-input>
            </el-form-item>
            <el-form-item prop="phoneCode">
              <div class="icon">
                <img src="@/assets/images/yzcode.png" alt="">
              </div>
              <el-input placeholder="请输入手机验证码" v-model="registerForm.phoneCode" maxlength="6"></el-input>
              <p class="getYzCode" @click="getCode">
                <span v-if="sendMsgDisabled">{{ code_text }}</span>
                <span v-if="!sendMsgDisabled">{{this.second}} s</span>
              </p>
            </el-form-item>
            <el-form-item class="btn" :class="{activeBtn:checked}">
              <el-button @click.prevent="register">注册</el-button>
            </el-form-item>
          </el-form>
          <p class="bottom-font" @click="login">
            <span>已有账户，</span>
            <span>立即登录</span>
          </p>
          <Verify
            @success="success"
            :mode="'pop'"
            :captchaType="'blockPuzzle'"
            :imgSize="{ width: '330px', height: '155px' }"
            ref="verify"
            v-if="isVerify"
          ></Verify>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Verify from "@/components/verifition/Verify";
import user from "@/apis/user_apis";
import { registerRules } from "@/validate/rules";
import utils from "@/utils/utils.js";
import vHeader from "@/layout/components/header";

export default {
  data() {
    return {
      registerForm: {
        password: "",
        phone: "",
        phoneCode: ""
      },
      checked: true,
      rules: registerRules,
      timer: null,
      second: 60,
      req_time: "",
      sendMsgDisabled: true,
      code_text: "发送验证码",
      show: true,
      isVerify: false,
      captcha:'',
    };
  },
  created(){
  },
  mounted() {
  },
  components: {
    vHeader,Verify
  },
  methods: {
    success(params) {
      this.captcha = params.captchaVerification; //滑动验证码
      this.isVerify = false; //行为验证成功
      this.getphoneCode ();
    },
    // 去登录
    login() {
      this.$toast(true)
    },
    // 校验注册
    register() {
      let that = this;
      that.$refs.registerForm.validate(valid => {
        if (valid) {
          if (that.checked) {
            user.register(that).then(res => {
              if (res.success) {
                that.$message({
                  message: "恭喜您，已注册成功！",
                  type: "success",
                  onClose: () => {
                    this.$toast(true)
                  }
                });
              }
            });
          } else {
            this.$message.warning("请勾选我同意");
            return;
          }
        } else {
          return false;
        }
      });
    },

    //点击获取图片验证
    getCode() {
      let that = this;
      this.$refs.registerForm.validateField("phone", valid => {
        if (!valid) {
          if (this.sendMsgDisabled) {
            this.isVerify = true
            this.$nextTick(()=>{
              this.$refs.verify.show();
            })
          } else {
            return;
          }
        } else {
          return false;
        }
      });
    },
    //获取短信验证码
    getphoneCode(){
      const query = {
        mobile:this.registerForm.phone,
        captcha:this.captcha,
        smsType:'register',
      }
      let that = this;
      user.sendsmscode(query).then(res => {
        if (res.success) {
          that.sendMsgDisabled = false;
          that.$message({
            message: "验证码10分钟有效",
            type: "success"
          });
          that.timer = setInterval(() => {
            that.second--;
            if (that.second <= 0) {
              clearTimeout(that.timer);
              that.sendMsgDisabled = true;
              that.second = 60;
              that.code_text = "重新获取";
            }
          }, 1000);
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
.registers {
  margin-bottom: 80px;
  
  .registers-layout {
    box-shadow: 0px 3px 28px rgba(51, 51, 51, 0.06);
    border-radius: 0 40px 0 40px;
    width: 1200px;
    height: 600px;
    margin: 0 auto;
    margin-top: 100px;
    display: flex;

    > div {
      flex-basis: 50%;
    }

    .left {
      background: #fabe00;
      border-radius: 0 0 0 40px;
      padding: 36px 14px 46px 27px;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .right {
      .title {
        text-align: center;
        margin-top: 100px;
        color: #333333;
        font-size: 30px;
      }
      .middle {
        width: 300px;
        margin: 0 auto;
        margin-top: 6px;

        .hint {
          display: flex;
          justify-content: space-between;
          margin-top: 20px;
          color: #999999;
          font-size: 12px;
          cursor: pointer;
          padding-left: 8px;

          /deep/.el-checkbox__label {
            font-size: 12px;
            color: #bfbfbf;
          }

          span {
            color: #fabe00;
          }
        }
        .el-form-item {
          box-sizing: border-box;
          height: 60px;
          margin-bottom: 0px !important;
          position: relative;
          padding-top: 18px;

          .icon {
            position: absolute;
            z-index: 22;
            height: 35px;
            width: 30px;
            text-align: center;
            left: 0;
            bottom: 1px;

            img {
              max-width: 18px;
              max-height: 20px;
              margin-bottom: 11px;
            }
          }

          .last-icon {
            width: 23px;
            height: 14px;
            position: absolute;
            z-index: 22;
            bottom: 11px;
            right: 0;
          }
        }
        .getCode {
          position: absolute;
          right: 0;
          bottom: 8px;
          display: inline-block;
          width: 80px;
          height: 30px;
          line-height: 30px;
          font-size: 14px;
          text-align: center;
          color: #fff;
          background: #9f9f9f;
          border-radius: 4px;
          cursor: pointer;
        }
        .getYzCode {
          position: absolute;
          right: 0;
          bottom: 8px;
          display: inline-block;
          width: 80px;
          height: 30px;
          line-height: 30px;
          font-size: 12px;
          text-align: center;
          color: #fabe00;
          background: rgba(250, 190, 0, 0.1);
          border: 1px solid rgba(250, 190, 0, 1);
          border-radius: 2px;
          cursor: pointer;
        }
        /deep/ .el-input__inner {
          height: 35px;
          border-radius: 0;
          border: none;
          border-bottom: 1px solid #e9e9f0;
          padding: 0 35px;
        }
        /deep/ .el-input__inner:focus {
          caret-color: #fabe00;
          border-bottom-color: #fabe00;
        }
        /deep/ .el-form-item__label {
          height: 50px !important;
          text-align: left !important;
          line-height: 50px !important;
          border-bottom: 1px solid #e9e9f0 !important;
        }
        .btn {
          margin-top: 30px;
          padding-top: 0;
          height: auto;

          /deep/ .el-form-item__content {
            margin-left: 0 !important;
          }
        }

        /deep/ .el-button + .el-button {
          margin-left: 30px !important;
        }
        /deep/ .el-button {
          padding: 0;
          width: 300px;
          height: 41px;
          font-size: 14px;
          border: 1px solid rgba(250, 217, 0, 1);
          color: #333;
          font-weight: normal;
          border-radius: 2px;
          background: linear-gradient(
            90deg,
            rgba(250, 217, 0, 1) 0%,
            rgba(250, 190, 0, 1) 100%
          );
          box-shadow: 0px 3px 12px rgba(250, 190, 0, 0.5);
        }
        /deep/ .el-button:hover {
          color: #fff;
          background: rgba(252, 111, 25, 1);
          box-shadow: 0px 3px 12px rgba(250, 108, 0, 0.3);
        }
        /deep/ .el-checkbox__inner {
          border: 1px solid #808495;
        }
        /deep/ .el-checkbox__input.is-checked .el-checkbox__inner {
          border: 1px solid #fabe01;
          background: #fabe01;

          &::after {
            border-color: #333333;
          }
        }
        .bottom-font {
          margin-top: 23px;
          text-align: center;
          font-size: 12px;
          cursor: pointer;
          & span:nth-child(1) {
            color: #333;
          }
          & span:nth-child(2) {
            color: #fabe01;
          }
        }
      }
    }
  }
}
</style>